// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"324":"bdd0371d","666":"861a3546","972":"a2e98408"}[chunkId] + ".chunk.css";
};